import SinginContainer from '../../containers/auth/SigninContainer'

const SigninPage = () => {
  return <SinginContainer />
}
export default SigninPage
